import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Snackbar } from '@material-ui/core';

import AvailabilityBox from './AvailabilityBox';
import { UserType } from '../../validation';

class Availability extends Component {
  constructor(props) {
    super(props);
    this.state = {
      includeWeekend: false,
      snackbarMessage: null,
      snackOpen: false
    };
  }

  handleSnackbarClose = () => {
    this.setState({ snackOpen: false });
  };

  displaySnackbar = message => {
    this.setState({
      snackOpen: true,
      snackbarMessage: message
    });
  };

  setIncludeWeekend = () => {
    this.setState(prevState => {
      return {
        includeWeekend: !prevState.includeWeekend
      };
    });
  };

  render() {
    const { includeWeekend, snackbarMessage, snackOpen } = this.state;
    const { 
      studioEmployeeId, 
      handleRequestAvailability, 
      isFullTime, 
      user, 
      employee 
    } = this.props;


    const canEdit = user.scopes.includes('employees:write')
      || (employee && employee.email.toLowerCase() === user.email.toLowerCase() && user.scopes.includes('my-availabilities:write'));

    const allowLastMinuteEdit = user.scopes.includes('last-minute-availabilities:write') && user.scopes.includes('employees:write')

    return (
      <>
        <AvailabilityBox
          studioEmployeeId={studioEmployeeId}
          isFullTime={isFullTime}
          includeWeekend={includeWeekend}
          displaySnackbar={this.displaySnackbar}
          onWeekendClick={this.setIncludeWeekend}
          handleRequestAvailability={handleRequestAvailability}
          canEdit={canEdit}
          allowLastMinuteEdit={allowLastMinuteEdit}
        />
        <Snackbar
          message={snackbarMessage}
          open={snackOpen}
          onClose={this.handleSnackbarClose}
          autoHideDuration={2000}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

Availability.propTypes = {
  studioEmployeeId: PropTypes.number.isRequired,
  handleRequestAvailability: PropTypes.func.isRequired,
  isFullTime: PropTypes.bool.isRequired,
  employee: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array, PropTypes.bool, PropTypes.object])).isRequired,
  user: UserType.isRequired
};

export { Availability as AvailabilityNoConnect };
export default connect(mapStateToProps)(Availability);
